import { katTranslator } from '../../shared/i18n';

const strings = {
  'currency-selector-AED': {
    'en-US': 'United Arab Emirates Dirham',
    'ar-AE': 'درهم إماراتي',
    'bn-IN': 'সংযুক্ত আরব আমিরাত দিরহাম',
    'de-DE': 'VAE-Dirham',
    'es-ES': 'Dírham de los Emiratos Árabes Unidos',
    'es-MX': 'Dírham de los Emiratos Árabes Unidos',
    'fr-BE': 'Dirham des Émirats arabes unis',
    'fr-FR': 'Dirham des Émirats arabes unis',
    'gu-IN': 'સંયુક્ત આરબ અમિરાત દિરહામ',
    'hi-IN': 'संयुक्त अरब अमीरात दिरहम',
    'it-IT': 'Dirham degli Emirati Arabi Uniti',
    'ja-JP': 'アラブ首長国連邦ディルハム',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಅರಬ್ ಎಮಿರೇಟ್ಸ್ ದಿರ್ಹಾಮ್',
    'ko-KR': '아랍 에미리트 연합국 디르함',
    'ml-IN': 'യുണൈറ്റഡ് അറബ് എമിറേറ്റ്സ് ദിർഹം',
    'mr-IN': 'युनायटेड अरब अमिरात दिरहाम',
    'nl-BE': 'VAE-dirham',
    'nl-NL': 'VAE-dirham',
    'pl-PL': 'Dirham emiracki',
    'pt-BR': 'Dirham dos Emirados Árabes Unidos',
    'pt-PT': 'Dirham dos Emirados Árabes Unidos',
    'sv-SE': 'Emiratisk dirham',
    'ta-IN': 'ஐக்கிய அரபு அமீரக திர்ஹம்',
    'te-IN': 'యునైటెడ్ అరబ్ ఎమిరేట్స్ దిరామ్',
    'th-TH': 'เดอร์แฮมสหรัฐอาหรับเอมิเรตส์',
    'tr-TR': 'Birleşik Arap Emirlikleri dirhemi',
    'vi-VN': 'Dirham Các Tiểu vương quốc Ả Rập Thống nhất',
    'zh-CN': '阿联酋迪拉姆',
    'zh-TW': '阿拉伯聯合大公國迪拉姆',
  },
  'currency-selector-AUD': {
    'en-US': 'Australian Dollar',
    'ar-AE': 'دولار أسترالي',
    'bn-IN': 'অস্ট্রেলিয়ান ডলার',
    'de-DE': 'Australischer Dollar',
    'es-ES': 'Dólar australiano',
    'es-MX': 'Dólar australiano',
    'fr-BE': 'Dollar australien',
    'fr-FR': 'Dollar australien',
    'gu-IN': 'ઓસ્ટ્રેલિયન ડોલર',
    'hi-IN': 'ऑस्ट्रेलियाई डॉलर',
    'it-IT': 'Dollaro australiano',
    'ja-JP': 'オーストラリアドル',
    'kn-IN': 'ಆಸ್ಟ್ರೇಲಿಯನ್ ಡಾಲರ್',
    'ko-KR': '오스트레일리아 달러',
    'ml-IN': 'ഓസ്ട്രേലിയൻ ഡോളർ',
    'mr-IN': 'ऑस्ट्रेलियन डॉलर',
    'nl-BE': 'Australische dollar',
    'nl-NL': 'Australische dollar',
    'pl-PL': 'Dolar australijski',
    'pt-BR': 'Dólar australiano',
    'pt-PT': 'Dólar australiano',
    'sv-SE': 'Australiensisk dollar',
    'ta-IN': 'ஆஸ்திரேலிய டாலர்',
    'te-IN': 'ఆస్ట్రేలియన్ డాలర్',
    'th-TH': 'ดอลลาร์ออสเตรเลีย',
    'tr-TR': 'Avustralya doları',
    'vi-VN': 'Đô la Úc',
    'zh-CN': '澳元',
    'zh-TW': '澳幣',
  },
  'currency-selector-BGN': {
    'en-US': 'Bulgarian Lev',
    'ar-AE': 'ليف بلغاري',
    'bn-IN': 'বুলগেরিয়ান লেভ',
    'de-DE': 'Bulgarischer Lew',
    'es-ES': 'Leva búlgara',
    'es-MX': 'Lev búlgaro',
    'fr-BE': 'Lev bulgare',
    'fr-FR': 'Lev bulgare',
    'gu-IN': 'બલ્ગેરિયન લેવ',
    'hi-IN': 'बुल्गारियाई लेव',
    'it-IT': 'Lev bulgaro',
    'ja-JP': 'ブルガリアレフ',
    'kn-IN': 'ಬಲ್ಗೇರಿಯನ್ ಲೆವ್',
    'ko-KR': '불가리아 레프',
    'ml-IN': 'ബൾഗേറിയൻ ലെവ്',
    'mr-IN': 'बल्गेरियन लेव',
    'nl-BE': 'Bulgaarse lev',
    'nl-NL': 'Bulgaarse lev',
    'pl-PL': 'Lew bułgarski',
    'pt-BR': 'Lev búlgaro',
    'pt-PT': 'Lev búlgaro',
    'sv-SE': 'Bulgarisk lev',
    'ta-IN': 'பல்கேரியன் லேவ்',
    'te-IN': 'బల్గేరియన్ లెవ్',
    'th-TH': 'เลฟบัลแกเรีย',
    'tr-TR': 'Bulgar levası',
    'vi-VN': 'Lev Bulgaria',
    'zh-CN': '保加利亚列弗',
    'zh-TW': '保加利亞列弗',
  },
  'currency-selector-BRL': {
    'en-US': 'Brazilian Real',
    'ar-AE': 'ريال برازيلي',
    'bn-IN': 'ব্রাজিলিয়ান রিয়েল',
    'de-DE': 'Brasilianischer Real',
    'es-ES': 'Real brasileño',
    'es-MX': 'Real brasileño',
    'fr-BE': 'Réal brésilien',
    'fr-FR': 'Réal brésilien',
    'gu-IN': 'બ્રાઝિલિયન રિઅલ',
    'hi-IN': 'ब्राज़ीलियन रियल',
    'it-IT': 'Real brasiliano',
    'ja-JP': 'ブラジルレアル',
    'kn-IN': 'ಬ್ರೆಜಿಲಿಯನ್ ರಿಯಲ್',
    'ko-KR': '브라질 헤알',
    'ml-IN': 'ബ്രസീലിയൻ റിയൽ',
    'mr-IN': 'ब्राझिलियन रिअल',
    'nl-BE': 'Braziliaanse real',
    'nl-NL': 'Braziliaanse real',
    'pl-PL': 'Real brazylijski',
    'pt-BR': 'Real brasileiro',
    'pt-PT': 'Real brasileiro',
    'sv-SE': 'Brasiliansk real',
    'ta-IN': 'பிரேசிலிய ரியல்',
    'te-IN': 'బ్రెజిలియన్ రియల్',
    'th-TH': 'เรอัลบราซิล',
    'tr-TR': 'Brezilya reali',
    'vi-VN': 'Real Brazil',
    'zh-CN': '巴西雷亚尔',
    'zh-TW': '巴西雷亞爾',
  },
  'currency-selector-CAD': {
    'en-US': 'Canadian Dollar',
    'ar-AE': 'دولار كندي',
    'bn-IN': 'কানাডিয়ান ডলার',
    'de-DE': 'Kanadischer Dollar',
    'es-ES': 'Dólar canadiense',
    'es-MX': 'Dólar canadiense',
    'fr-BE': 'Dollar canadien',
    'fr-FR': 'Dollar canadien',
    'gu-IN': 'કેનેડિયન ડોલર',
    'hi-IN': 'कैनेडियन डॉलर',
    'it-IT': 'Dollaro canadese',
    'ja-JP': 'カナダドル',
    'kn-IN': 'ಕೆನಡಿಯನ್ ಡಾಲರ್',
    'ko-KR': '캐나다 달러',
    'ml-IN': 'കനേഡിയൻ ഡോളർ',
    'mr-IN': 'कॅनेडियन डॉलर',
    'nl-BE': 'Canadese dollar',
    'nl-NL': 'Canadese dollar',
    'pl-PL': 'Dolar kanadyjski',
    'pt-BR': 'Dólar canadense',
    'pt-PT': 'Dólar canadiano',
    'sv-SE': 'Kanadensisk dollar',
    'ta-IN': 'கனடிய டாலர்',
    'te-IN': 'కెనడియన్ డాలర్',
    'th-TH': 'ดอลลาร์แคนาดา',
    'tr-TR': 'Kanada doları',
    'vi-VN': 'Đô la Canada',
    'zh-CN': '加元',
    'zh-TW': '加幣',
  },
  'currency-selector-CHF': {
    'en-US': 'Swiss Franc',
    'ar-AE': 'فرنك سويسري',
    'bn-IN': 'সুইস ফ্রাঙ্ক',
    'de-DE': 'Schweizer Franken',
    'es-ES': 'Franco suizo',
    'es-MX': 'Franco suizo',
    'fr-BE': 'Francs suisses',
    'fr-FR': 'Franc suisse',
    'gu-IN': 'સ્વિસ ફ્રાન્ક',
    'hi-IN': 'स्विस फ़्रैंक',
    'it-IT': 'Franco svizzero',
    'ja-JP': 'スイスフラン',
    'kn-IN': 'ಸ್ವಿಸ್ ಫ್ರಾಂಕ್',
    'ko-KR': '스위스 프랑',
    'ml-IN': 'സ്വിസ് ഫ്രാങ്ക്',
    'mr-IN': 'स्विस फ्रँक',
    'nl-BE': 'Zwitserse frank',
    'nl-NL': 'Zwitserse frank',
    'pl-PL': 'Frank szwajcarski',
    'pt-BR': 'Franco suíço',
    'pt-PT': 'Franco Suíço',
    'sv-SE': 'Schweizisk franc',
    'ta-IN': 'சுவிஸ் பிரான்க்',
    'te-IN': 'స్విస్ ఫ్రాంక్',
    'th-TH': 'ฟรังก์สวิส',
    'tr-TR': 'İsviçre frangı',
    'vi-VN': 'Franc Thụy Sĩ',
    'zh-CN': '瑞士法郎',
    'zh-TW': '瑞士法郎',
  },
  'currency-selector-CLP': {
    'en-US': 'Chilean Peso',
    'ar-AE': 'بيزو تشيلي',
    'bn-IN': 'চিলিয়ান পেসো',
    'de-DE': 'Chilenischer Peso',
    'es-ES': 'Peso chileno',
    'es-MX': 'Peso chileno',
    'fr-BE': 'Peso chilien',
    'fr-FR': 'Peso chilien',
    'gu-IN': 'ચિલીના પેસો',
    'hi-IN': 'चीलीयन पेसो',
    'it-IT': 'Peso cileno',
    'ja-JP': 'チリペソ',
    'kn-IN': 'ಚಿಲಿಯ ಪೆಸೊ',
    'ko-KR': '칠레 페소',
    'ml-IN': 'ചിലിയൻ പെസോ',
    'mr-IN': 'चिलीयन पेसो',
    'nl-BE': 'Chileense peso',
    'nl-NL': 'Chileense peso',
    'pl-PL': 'Peso chilijskie',
    'pt-BR': 'Peso chileno',
    'pt-PT': 'Peso Chileno',
    'sv-SE': 'Chilensk peso',
    'ta-IN': 'சிலியன் பெசோ',
    'te-IN': 'చిలియన్ పెసో',
    'th-TH': 'เปโซชิลี',
    'tr-TR': 'Şili pesosu',
    'vi-VN': 'Peso Chile',
    'zh-CN': '智力比索',
    'zh-TW': '智利披索',
  },
  'currency-selector-CNY': {
    'en-US': 'Chinese Yuan',
    'ar-AE': 'يوان صيني',
    'bn-IN': 'চীনা ইউয়ান',
    'de-DE': 'Chinesischer Yuan',
    'es-ES': 'Yuan chino',
    'es-MX': 'Yuan chino',
    'fr-BE': 'Yuan chinois',
    'fr-FR': 'Yuan chinois',
    'gu-IN': 'ચિની યુઆન',
    'hi-IN': 'चाइनीज़ युआन',
    'it-IT': 'Yuan cinese',
    'ja-JP': '中国元',
    'kn-IN': 'ಚೈನೀಸ್ ಯುವಾನ್',
    'ko-KR': '중국 위안',
    'ml-IN': 'ചൈനീസ് യുവാൻ',
    'mr-IN': 'चिनी युआन',
    'nl-BE': 'Chinese yuan',
    'nl-NL': 'Chinese yuan',
    'pl-PL': 'Juan chiński',
    'pt-BR': 'Yuan chinês',
    'pt-PT': 'Yuan Chinês',
    'sv-SE': 'Kinesisk yuan',
    'ta-IN': 'சீன யுவான்',
    'te-IN': 'చైనీస్ యువాన్',
    'th-TH': 'หยวนจีน',
    'tr-TR': 'Çin yuanı',
    'vi-VN': 'Nhân dân tệ Trung Quốc',
    'zh-CN': '人民币',
    'zh-TW': '中國人民幣',
  },
  'currency-selector-COP': {
    'en-US': 'Colombian Peso',
    'ar-AE': 'بيزو كولومبي',
    'bn-IN': 'কলম্বিয়ান পেসো',
    'de-DE': 'Kolumbianischer Peso',
    'es-ES': 'Peso colombiano',
    'es-MX': 'Peso colombiano',
    'fr-BE': 'Peso colombien',
    'fr-FR': 'Peso colombien',
    'gu-IN': 'કોલમ્બિયન પેસો',
    'hi-IN': 'कोलंबिया पेसो',
    'it-IT': 'Peso colombiano',
    'ja-JP': 'コロンビアペソ',
    'kn-IN': 'ಕೊಲಂಬಿಯಾದ ಪೆಸೊ',
    'ko-KR': '콜롬비아 페소',
    'ml-IN': 'കൊളംബിയൻ പെസോ',
    'mr-IN': 'कोलंबियन पेसो',
    'nl-BE': 'Colombiaanse peso',
    'nl-NL': 'Colombiaanse peso',
    'pl-PL': 'Peso kolumbijskie',
    'pt-BR': 'Peso colombiano',
    'pt-PT': 'Peso colombiano',
    'sv-SE': 'Colombiansk peso',
    'ta-IN': 'கொலம்பிய பேஸோ',
    'te-IN': 'కొలంబియన్ పెసో',
    'th-TH': 'เปโซโคลอมเบีย',
    'tr-TR': 'Kolombiya pesosu',
    'vi-VN': 'Peso Colombia',
    'zh-CN': '哥伦比亚比索',
    'zh-TW': '哥倫比亞披索',
  },
  'currency-selector-DKK': {
    'en-US': 'Danish Krone',
    'ar-AE': 'كرونة دنماركية',
    'bn-IN': 'ডেনিশ ক্রোন',
    'de-DE': 'Dänische Krone',
    'es-ES': 'Corona danesa',
    'es-MX': 'Corona danesa',
    'fr-BE': 'Couronne danoise',
    'fr-FR': 'Couronnes danoises',
    'gu-IN': 'ડેનિશ ક્રોન',
    'hi-IN': 'डेनिश क्रोन',
    'it-IT': 'Corona danese',
    'ja-JP': 'デンマーククローネ',
    'kn-IN': 'ಡ್ಯಾನಿಶ್ ಕ್ರೋನ್',
    'ko-KR': '덴마크 크로네',
    'ml-IN': 'ഡാനിഷ് ക്രോണെ',
    'mr-IN': 'डॅनिश क्रोन',
    'nl-BE': 'Deense kroon',
    'nl-NL': 'Deense kroon',
    'pl-PL': 'Korona duńska',
    'pt-BR': 'Coroa dinamarquesa',
    'pt-PT': 'Coroa Dinamarquesa',
    'sv-SE': 'Dansk krona',
    'ta-IN': 'டேனிஷ் க்ரோன்',
    'te-IN': 'డానిష్ క్రోన్',
    'th-TH': 'โครนเดนมาร์ก',
    'tr-TR': 'Danimarka kronu',
    'vi-VN': 'Krone Đan Mạch',
    'zh-CN': '丹麦克朗',
    'zh-TW': '丹麥克朗',
  },
  'currency-selector-EGP': {
    'en-US': 'Egyptian Pound',
    'ar-AE': 'جنيه مصري',
    'bn-IN': 'ইজিপ্টিয়ান পাউন্ড',
    'de-DE': 'Ägyptisches Pfund',
    'es-ES': 'Libra egipcia',
    'es-MX': 'Libra egipcia',
    'fr-BE': 'Livre égyptienne',
    'fr-FR': 'Livre égyptienne',
    'gu-IN': 'ઇજિપ્તિયન પાઉન્ડ',
    'hi-IN': 'इजिप्टियन पाउंड',
    'it-IT': 'Sterlina egiziana',
    'ja-JP': 'エジプトポンド',
    'kn-IN': 'ಈಜಿಪ್ಟಿಯನ್ ಪೌಂಡ್',
    'ko-KR': '이집트 파운드',
    'ml-IN': 'ഈജിപ്ഷ്യൻ പൗണ്ട്',
    'mr-IN': 'इजिप्शियन पाउंड',
    'nl-BE': 'Egyptisch pond',
    'nl-NL': 'Egyptische pond',
    'pl-PL': 'Funt egipski',
    'pt-BR': 'Libra egípcia',
    'pt-PT': 'Libra Egípcia',
    'sv-SE': 'Egyptiskt pund',
    'ta-IN': 'எகிப்தியன் பவுண்டு',
    'te-IN': 'ఈజిప్షియన్ పౌండ్',
    'th-TH': 'ปอนด์อียิปต์',
    'tr-TR': 'Mısır poundu',
    'vi-VN': 'Bảng Ai Cập',
    'zh-CN': '埃及镑',
    'zh-TW': '埃及鎊',
  },
  'currency-selector-EUR': {
    'en-US': 'Euro',
    'ar-AE': 'يورو',
    'bn-IN': 'ইউরো',
    'gu-IN': 'યુરો',
    'hi-IN': 'यूरो',
    'ja-JP': 'ユーロ',
    'kn-IN': 'ಯುರೋ',
    'ml-IN': 'യൂറോ',
    'mr-IN': 'युरो',
    'ta-IN': 'யூரோ',
    'te-IN': 'యూరో',
    'th-TH': 'ยูโร',
    'zh-CN': '欧元',
    'zh-TW': '歐元',
  },
  'currency-selector-GBP': {
    'en-US': 'Pound Sterling',
    'ar-AE': 'جنيه إسترليني',
    'bn-IN': 'পাউন্ড স্টার্লিং',
    'de-DE': 'Pfund Sterling',
    'es-ES': 'Libra esterlina',
    'es-MX': 'Libra esterlina',
    'fr-BE': 'Livre sterling',
    'fr-FR': 'Livre sterling',
    'gu-IN': 'પાઉન્ડ સ્ટર્લિંગ',
    'hi-IN': 'पाउंड स्टर्लिंग',
    'it-IT': 'Sterlina britannica',
    'ja-JP': '英ポンド',
    'kn-IN': 'ಪೌಂಡ್ ಸ್ಟರ್ಲಿಂಗ್',
    'ko-KR': '파운드 스털링',
    'ml-IN': 'പൗണ്ട് സ്റ്റെർലിംഗ്',
    'mr-IN': 'पाउंड स्टर्लिंग',
    'nl-BE': 'Pond sterling',
    'nl-NL': 'Pond sterling',
    'pl-PL': 'Funt szterling',
    'pt-BR': 'Libra esterlina',
    'pt-PT': 'Libra esterlina',
    'sv-SE': 'Brittiska pund',
    'ta-IN': 'பவுண்டு ஸ்டெர்லிங்',
    'te-IN': 'పౌండ్ స్టెర్లింగ్',
    'th-TH': 'ปอนด์สเตอร์ลิง',
    'tr-TR': 'İngiliz sterlini',
    'vi-VN': 'Bảng Anh',
    'zh-CN': '英镑',
    'zh-TW': '英鎊',
  },
  'currency-selector-HKD': {
    'en-US': 'Hong Kong Dollar',
    'ar-AE': 'دولار هونج كونج',
    'bn-IN': 'হংকং ডলার',
    'de-DE': 'Hongkong-Dollar',
    'es-ES': 'Dólar de Hong Kong',
    'es-MX': 'Dólar de Hong Kong',
    'fr-BE': 'Dollar de Hong Kong',
    'fr-FR': 'Dollar de Hong Kong',
    'gu-IN': 'હોંગ કોંગ ડૉલર',
    'hi-IN': 'हॉन्ग कॉन्ग डॉलर',
    'it-IT': 'Dollaro di Hong Kong',
    'ja-JP': '香港ドル',
    'kn-IN': 'ಹಾಂಗ್ ಕಾಂಗ್ ಡಾಲರ್',
    'ko-KR': '홍콩 달러',
    'ml-IN': 'ഹോങ്കോംഗ് ഡോളർ',
    'mr-IN': 'हाँगकाँग डॉलर',
    'nl-BE': 'Hongkongse dollar',
    'nl-NL': 'Hongkongse dollar',
    'pl-PL': 'Dolar hongkoński',
    'pt-BR': 'Dólar de Hong Kong',
    'pt-PT': 'Dólar de Hong Kong',
    'sv-SE': 'Hongkong-dollar',
    'ta-IN': 'ஹாங்காங் டாலர்',
    'te-IN': 'హాంకాంగ్ డాలర్',
    'th-TH': 'ดอลลาร์ฮ่องกง',
    'tr-TR': 'Hong Kong doları',
    'vi-VN': 'Đô la Hồng Kông',
    'zh-CN': '港币',
    'zh-TW': '港幣',
  },
  'currency-selector-ILS': {
    'en-US': 'Israeli Shekel',
    'ar-AE': 'شيكل إسرائيلي',
    'bn-IN': 'ইসরায়েলি শেকেল',
    'de-DE': 'Israelischer Schekel',
    'es-ES': 'Shekel israelí',
    'es-MX': 'Nuevo séquel israelí',
    'fr-BE': 'Shekel israélien',
    'fr-FR': 'Shekel israélien',
    'gu-IN': 'ઇઝરાયેલી શેકેલ',
    'hi-IN': 'इजरायली शेकेल',
    'it-IT': 'Shekel israeliano',
    'ja-JP': 'イスラエルシェケル',
    'kn-IN': 'ಇಸ್ರೇಲಿ ಶೇಖಲ್',
    'ko-KR': '이스라엘 셰켈',
    'ml-IN': 'ഇസ്രായേലി ഷെക്കെൽ',
    'mr-IN': 'इस्रायली शेकेल',
    'nl-BE': 'Israëlische sjekel',
    'nl-NL': 'Israëlische sjekel',
    'pl-PL': 'Szekel izraelski',
    'pt-BR': 'Shekel israelense',
    'pt-PT': 'Shekel israelita',
    'sv-SE': 'Israelisk shekel',
    'ta-IN': 'இஸ்ரேலிய ஷேகல்',
    'te-IN': 'ఇజ్రాయెల్ షెకోల్',
    'th-TH': 'เชเกลอิสราเอล',
    'tr-TR': 'İsrail şekeli',
    'vi-VN': 'Shekel Israel',
    'zh-CN': '以色列谢克尔',
    'zh-TW': '以色列謝克爾',
  },
  'currency-selector-INR': {
    'en-US': 'Indian Rupee',
    'ar-AE': 'روبية هندية',
    'bn-IN': 'ভারতীয় রুপি',
    'de-DE': 'Indische Rupie',
    'es-ES': 'Rupia india',
    'es-MX': 'Rupia india',
    'fr-BE': 'Roupie indienne',
    'fr-FR': 'Roupie indienne',
    'gu-IN': 'ભારતીય રૂપિયા',
    'hi-IN': 'भारतीय रुपया',
    'it-IT': 'Rupia indiana',
    'ja-JP': 'インドルピー',
    'kn-IN': 'ಭಾರತೀಯ ರೂಪಾಯಿ',
    'ko-KR': '인도 루피',
    'ml-IN': 'ഇന്ത്യൻ രൂപ',
    'mr-IN': 'भारतीय रुपया',
    'nl-BE': 'Indiase roepie',
    'nl-NL': 'Indiase roepie',
    'pl-PL': 'Rupia indyjska',
    'pt-BR': 'Rúpia indiana',
    'pt-PT': 'Rupia indiana',
    'sv-SE': 'Indisk rupie',
    'ta-IN': 'இந்திய ரூபாய்',
    'te-IN': 'భారత రూపాయి',
    'th-TH': 'รูปีอินเดีย',
    'tr-TR': 'Hindistan rupisi',
    'vi-VN': 'Rupee Ấn Độ',
    'zh-CN': '印度卢比',
    'zh-TW': '印度盧比',
  },
  'currency-selector-JPY': {
    'en-US': 'Japanese Yen',
    'ar-AE': 'ين ياباني',
    'bn-IN': 'জাপানি ইয়েন',
    'de-DE': 'Japanischer Yen',
    'es-ES': 'Yen japonés',
    'es-MX': 'Yen japonés',
    'fr-BE': 'Yen japonais',
    'fr-FR': 'Yen japonais',
    'gu-IN': 'જાપાનીઝ યેન',
    'hi-IN': 'जापानी येन',
    'it-IT': 'Yen giapponese',
    'ja-JP': '日本円',
    'kn-IN': 'ಜಪಾನೀಸ್ ಯೆನ್',
    'ko-KR': '일본 엔',
    'ml-IN': 'ജാപ്പനീസ് യെൻ',
    'mr-IN': 'जपानी येन',
    'nl-BE': 'Japanse yen',
    'nl-NL': 'Japanse yen',
    'pl-PL': 'Jen japoński',
    'pt-BR': 'Iene japonês',
    'pt-PT': 'Iene japonês',
    'sv-SE': 'Japansk yen',
    'ta-IN': 'ஜப்பானிய யென்',
    'te-IN': 'జపనీస్ యెన్',
    'th-TH': 'เยนญี่ปุ่น',
    'tr-TR': 'Japon yeni',
    'vi-VN': 'Yên Nhật',
    'zh-CN': '日元',
    'zh-TW': '日圓',
  },
  'currency-selector-KRW': {
    'en-US': 'South Korean Won',
    'ar-AE': 'وون كوري جنوبي',
    'bn-IN': 'দক্ষিণ কোরিয়ান ওন',
    'de-DE': 'Südkoreanischer Won',
    'en-GB': 'South Korean Won/United States Dollar',
    'es-ES': 'Won surcoreano',
    'es-MX': 'Won surcoreano',
    'fr-BE': 'Won sud-coréen',
    'fr-FR': 'Won sud-coréen',
    'gu-IN': 'દક્ષિણ કોરિયન વોન',
    'hi-IN': 'दक्षिण कोरियाई वॉन',
    'it-IT': 'Won coreano',
    'ja-JP': '韓国ウォン',
    'kn-IN': 'ಸೌತ್ ಕೊರಿಯನ್ ವೊನ್',
    'ko-KR': '대한민국 원',
    'ml-IN': 'ദക്ഷിണ കൊറിയൻ വോൺ',
    'mr-IN': 'दक्षिण कोरियन वोन',
    'nl-BE': 'Zuid-Koreaanse won',
    'nl-NL': 'Zuid-Koreaanse won',
    'pl-PL': 'Won południowokoreański',
    'pt-BR': 'Won sul-coreano',
    'pt-PT': 'Won sul-coreano',
    'sv-SE': 'Sydkoreansk won',
    'ta-IN': 'தென் கொரிய வான்',
    'te-IN': 'దక్షిణ కొరియా వాన్',
    'th-TH': 'วอนเกาหลีใต้',
    'tr-TR': 'Güney Kore wonu',
    'vi-VN': 'Won Hàn Quốc',
    'zh-CN': '韩国韩元',
    'zh-TW': '韓元',
  },
  'currency-selector-MXN': {
    'en-US': 'Mexican Peso',
    'ar-AE': 'بيزو مكسيكي',
    'bn-IN': 'মেক্সিকান পেসো',
    'de-DE': 'Mexikanischer Peso',
    'es-ES': 'Peso mexicano',
    'es-MX': 'Peso mexicano',
    'fr-BE': 'Peso mexicain',
    'fr-FR': 'Peso mexicain',
    'gu-IN': 'મેક્સિકન પેસો',
    'hi-IN': 'मैक्सिकन पेसो',
    'it-IT': 'Peso messicano',
    'ja-JP': 'メキシコペソ',
    'kn-IN': 'ಮೆಕ್ಸಿಕನ್ ಪೆಸೊ',
    'ko-KR': '멕시코 페소',
    'ml-IN': 'മെക്സിക്കൻ പെസോ',
    'mr-IN': 'मेक्सिकन पेसो',
    'nl-BE': 'Mexicaanse peso',
    'nl-NL': 'Mexicaanse peso',
    'pl-PL': 'Peso meksykańskie',
    'pt-BR': 'Peso mexicano',
    'pt-PT': 'Peso mexicano',
    'sv-SE': 'Mexikansk peso',
    'ta-IN': 'மெக்ஸிகன் பேஸோ',
    'te-IN': 'మెక్సికన్ పెసో',
    'th-TH': 'เปโซเม็กซิโก',
    'tr-TR': 'Meksika pesosu',
    'vi-VN': 'Peso Mexico',
    'zh-CN': '墨西哥比索',
    'zh-TW': '墨西哥披索',
  },
  'currency-selector-MYR': {
    'en-US': 'Malaysian Ringgit',
    'ar-AE': 'رينغيت ماليزي',
    'bn-IN': 'মালয়েশিয়ার রিঙ্গিত',
    'de-DE': 'Malaysischer Ringgit',
    'es-ES': 'Ringgit malayo',
    'es-MX': 'Ringgit malayo',
    'fr-BE': 'Ringgit malaisien',
    'fr-FR': 'Ringgit malais',
    'gu-IN': 'મલેશિયન રિન્જિટ',
    'hi-IN': 'मलेशियन रिंग्गित',
    'it-IT': 'Ringgit malese',
    'ja-JP': 'マレーシアリンギット',
    'kn-IN': 'ಮಲೇಷ್ಯಾದ ರಿಂಗಿಟ್',
    'ko-KR': '말레이시아 링깃',
    'ml-IN': 'മലേഷ്യൻ റിംഗിറ്റ്',
    'mr-IN': 'मलेशियन रिंगिट',
    'nl-BE': 'Maleisische ringgit',
    'nl-NL': 'Maleisische ringgit',
    'pl-PL': 'Ringgit malezyjski',
    'pt-BR': 'Ringgit malásio',
    'pt-PT': 'Ringgit da Malásia',
    'sv-SE': 'Malaysisk ringgit',
    'ta-IN': 'மலேஷியன் ரிங்கிட்',
    'te-IN': 'మలేషియా రింగ్గిట్',
    'th-TH': 'ริงกิตมาเลเซีย',
    'tr-TR': 'Malezya ringgiti',
    'vi-VN': 'Ringgit Malaysia',
    'zh-CN': '马来西亚林吉特',
    'zh-TW': '馬來西亞林吉特',
  },
  'currency-selector-NGN': {
    'en-US': 'Nigerian Naira',
    'ar-AE': 'نيرة نيجيرية',
    'bn-IN': 'নাইজেরিয়ান নায়রা',
    'de-DE': 'Nigerianischer Naira',
    'es-ES': 'Naira nigeriano',
    'es-MX': 'Naira nigeriano',
    'fr-BE': 'Naira nigérian',
    'fr-FR': 'Naira nigérian',
    'gu-IN': 'નાઇજિરિયન નૈરા',
    'hi-IN': 'नाइजीरियाई नाइरा',
    'it-IT': 'Naira nigeriana',
    'ja-JP': 'ナイジェリアナイラ',
    'kn-IN': 'ನೈಜೀರಿಯನ್ ನೈರಾ',
    'ko-KR': '나이지리아 나이라',
    'ml-IN': 'നൈജീരിയൻ നൈറ',
    'mr-IN': 'नायजेरियन नायरा',
    'nl-BE': 'Nigeriaanse naira',
    'nl-NL': 'Nigeriaanse naira',
    'pl-PL': 'Naira nigeryjska',
    'pt-BR': 'Naira nigeriana',
    'pt-PT': 'Naira nigeriano',
    'sv-SE': 'Nigeriansk naira',
    'ta-IN': 'நைஜீரியன் நைரா',
    'te-IN': 'నైజీరియన్ నైరా',
    'th-TH': 'ไนราไนจีเรีย',
    'tr-TR': 'Nijerya nairası',
    'vi-VN': 'Naira Nigeria',
    'zh-CN': '尼日利亚奈拉',
    'zh-TW': '奈及利亞奈拉',
  },
  'currency-selector-NZD': {
    'en-US': 'New Zealand Dollar',
    'ar-AE': 'دولار نيوزيلاندي',
    'bn-IN': 'নিউজিল্যান্ড ডলার',
    'de-DE': 'Neuseeland-Dollar',
    'es-ES': 'Dólar neozelandés',
    'es-MX': 'Dólar neozelandés',
    'fr-BE': 'Dollar néo-zélandais',
    'fr-FR': 'Dollar néo-zélandais',
    'gu-IN': 'ન્યુઝિલેન્ડ ડૉલર',
    'hi-IN': 'न्यूज़ीलैंड डॉलर',
    'it-IT': 'Dollaro neozelandese',
    'ja-JP': 'ニュージーランドドル',
    'kn-IN': 'ನ್ಯೂಜಿಲ್ಯಾಂಡ್ ಡಾಲರ್',
    'ko-KR': '뉴질랜드 달러',
    'ml-IN': 'ന്യൂസിലാൻ‌ഡ് ഡോളർ',
    'mr-IN': 'न्यूझीलंड डॉलर',
    'nl-BE': 'Nieuw-Zeelandse dollar',
    'nl-NL': 'Nieuw-Zeelandse dollar',
    'pl-PL': 'Dolar nowozelandzki',
    'pt-BR': 'Dólar neozelandês',
    'pt-PT': 'Dólar neozelandês',
    'sv-SE': 'Nyzeeländsk dollar',
    'ta-IN': 'நியூசிலாந்து டாலர்',
    'te-IN': 'న్యూజిలాండ్ డాలర్',
    'th-TH': 'ดอลลาร์นิวซีแลนด์',
    'tr-TR': 'Yeni Zelanda doları',
    'vi-VN': 'Đô la New Zealand',
    'zh-CN': '新西兰元',
    'zh-TW': '紐幣',
  },
  'currency-selector-PKR': {
    'en-US': 'Pakistani Rupee',
    'ar-AE': 'روبية باكستانية',
    'bn-IN': 'পাকিস্তানী রুপি',
    'de-DE': 'Pakistanische Rupie',
    'es-ES': 'Rupia pakistaní',
    'es-MX': 'Rupia pakistaní',
    'fr-BE': 'Roupie pakistanaise',
    'fr-FR': 'Roupie pakistanaise',
    'gu-IN': 'પાકિસ્તાની રૂપિયો',
    'hi-IN': 'पाकिस्तानी रुपया',
    'it-IT': 'Rupia pakistana',
    'ja-JP': 'パキスタンルピー',
    'kn-IN': 'ಪಾಕಿಸ್ತಾನಿ ರೂಪೀ',
    'ko-KR': '파키스탄 루피',
    'ml-IN': 'പാക്കിസ്ഥാനി റുപ്പീ',
    'mr-IN': 'पाकिस्तानी रुपया',
    'nl-BE': 'Pakistaanse roepie',
    'nl-NL': 'Pakistaanse roepie',
    'pl-PL': 'Rupia pakistańska',
    'pt-BR': 'Rúpia paquistanesa',
    'pt-PT': 'Rupia paquistanesa',
    'sv-SE': 'Pakistansk rupie',
    'ta-IN': 'பாகிஸ்தானிய ரூபாய்',
    'te-IN': 'పాకిస్థానీ రూపాయి',
    'th-TH': 'รูปีปากีสถาน',
    'tr-TR': 'Pakistan rupisi',
    'vi-VN': 'Rupee Pakistan',
    'zh-CN': '巴基斯坦卢比',
    'zh-TW': '巴基斯坦盧比',
  },
  'currency-selector-PLN': {
    'en-US': 'Polish Złoty',
    'ar-AE': 'زلوتي بولندي',
    'bn-IN': 'পোলিশ জালোটি',
    'de-DE': 'Polnischer Zloty',
    'es-ES': 'Esloti polaco',
    'es-MX': 'Zloty polaco',
    'fr-BE': 'Zloty polonais',
    'fr-FR': 'Złoty polonais',
    'gu-IN': 'પોલિશ ઝ્ડોટી',
    'hi-IN': 'पॉलिश ज़्लोटी',
    'it-IT': 'Złoty polacco',
    'ja-JP': 'ポーランドズオティ',
    'kn-IN': 'ಪೋಲಿಷ್ ಝ್ಲೋಟಿ',
    'ko-KR': '폴란드 즈워티',
    'ml-IN': 'പോളിഷ് സ്ലോട്ടി',
    'mr-IN': 'पोलिश झ्लोटी',
    'nl-BE': 'Poolse zloty',
    'nl-NL': 'Poolse złoty',
    'pl-PL': 'Złoty polski',
    'pt-BR': 'Złoty polonês',
    'pt-PT': 'Zlóti polaco',
    'sv-SE': 'Polsk złoty',
    'ta-IN': 'போலந்து ஸ்லோடி',
    'te-IN': 'పోలిష్ జ్లోటీ',
    'th-TH': 'ซวอตือโปแลนด์',
    'tr-TR': 'Polonya zlotisi',
    'vi-VN': 'Złoty Ba Lan',
    'zh-CN': '波兰兹罗提',
    'zh-TW': '波蘭茲羅提',
  },
  'currency-selector-RON': {
    'en-US': 'Romanian Leu',
    'ar-AE': 'ليو روماني',
    'bn-IN': 'রোমানিয়ান লিউ',
    'de-DE': 'Rumänischer Leu',
    'es-ES': 'Leu rumano',
    'es-MX': 'Leu rumano',
    'fr-BE': 'Leu roumain',
    'fr-FR': 'Leu roumain',
    'gu-IN': 'રોમાનિયન લેઉ',
    'hi-IN': 'रोमानियन लियू',
    'it-IT': 'Leu rumeno',
    'ja-JP': 'ルーマニアレイ',
    'kn-IN': 'ರೊಮೇನಿಯನ್ ಲಿಯು',
    'ko-KR': '루마니아 레우',
    'ml-IN': 'മാസിഡോണിയൻ ദിനാർ',
    'mr-IN': 'रोमानियन ल्यू',
    'nl-BE': 'Roemeense leu',
    'nl-NL': 'Roemeense leu',
    'pl-PL': 'Lej rumuński',
    'pt-BR': 'Leu romeno',
    'pt-PT': 'Leu romeno',
    'sv-SE': 'Rumänsk leu',
    'ta-IN': 'ரோமானியன் லியூ',
    'te-IN': 'రొమేనియన్ ల్యూ',
    'th-TH': 'ลิวโรมาเนีย',
    'tr-TR': 'Rumen leyi',
    'vi-VN': 'Leu Romania',
    'zh-CN': '罗马尼亚列伊',
    'zh-TW': '羅馬尼亞列伊',
  },
  'currency-selector-SAR': {
    'en-US': 'Saudi Riyal',
    'ar-AE': 'ريال سعودي',
    'bn-IN': 'সৌদি রিয়াল',
    'de-DE': 'Saudischer Riyal',
    'es-ES': 'Rial saudí',
    'es-MX': 'Rial saudí',
    'fr-BE': 'Rial saoudien',
    'fr-FR': 'Rial saoudien',
    'gu-IN': 'સાઉદી રિયાલ',
    'hi-IN': 'सऊदी रियाल',
    'it-IT': 'Riyal saudita',
    'ja-JP': 'サウジリヤル',
    'kn-IN': 'ಸೌದಿ ರಿಯಾಲ್',
    'ko-KR': '사우디 리얄',
    'ml-IN': 'സൗദി റിയാൽ',
    'mr-IN': 'सौदी रियाल',
    'nl-BE': 'Saoedi-Arabische riyal',
    'nl-NL': 'Saudi riyal',
    'pl-PL': 'Rial saudyjski',
    'pt-BR': 'Rial saudita',
    'pt-PT': 'Rial saudita',
    'sv-SE': 'Saudiarabisk rial',
    'ta-IN': 'சவூதி ரியால்',
    'te-IN': 'సౌదీ రియల్',
    'th-TH': 'ริยัลซาอุดี',
    'tr-TR': 'Suudi Arabistan riyali',
    'vi-VN': 'Riyal Ả Rập Xê Út',
    'zh-CN': '沙特里亚尔',
    'zh-TW': '沙烏地里亞爾',
  },
  'currency-selector-SEK': {
    'en-US': 'Swedish Krona',
    'ar-AE': 'كرونة سويدية',
    'bn-IN': 'সুইডিশ ক্রোনা',
    'de-DE': 'Schwedische Krone',
    'es-ES': 'Corona sueca',
    'es-MX': 'Corona sueca',
    'fr-BE': 'Couronne suédoise',
    'fr-FR': 'Couronne suédoise',
    'gu-IN': 'સ્વીડિશ ક્રોના',
    'hi-IN': 'स्वीडिश क्रोना',
    'it-IT': 'Corona svedese',
    'ja-JP': 'スウェーデンクローナ',
    'kn-IN': 'ಸ್ವೀಡಿಷ್ ಕ್ರೋನಾ',
    'ko-KR': '스웨덴 크로나',
    'ml-IN': 'സ്വീഡിഷ് ക്രോണ',
    'mr-IN': 'स्वीडिश क्रोना',
    'nl-BE': 'Zweedse kroon',
    'nl-NL': 'Zweedse kroon',
    'pl-PL': 'Korona szwedzka',
    'pt-BR': 'Coroa sueca',
    'pt-PT': 'Coroa sueca',
    'sv-SE': 'Svensk krona',
    'ta-IN': 'ஸ்வீடிஷ் க்ரோனா',
    'te-IN': 'స్వీడిష్ క్రోనా',
    'th-TH': 'โครนาสวีเดน',
    'tr-TR': 'İsveç kronu',
    'vi-VN': 'Krona Thụy Điển',
    'zh-CN': '瑞典克朗',
    'zh-TW': '瑞典克朗',
  },
  'currency-selector-SGD': {
    'en-US': 'Singapore Dollar',
    'ar-AE': 'دولار سنغافوري',
    'bn-IN': 'সিঙ্গাপুর ডলার',
    'de-DE': 'Singapur-Dollar',
    'es-ES': 'Dólar de Singapur',
    'es-MX': 'Dólar de Singapur',
    'fr-BE': 'Dollar de Singapour',
    'fr-FR': 'Dollar de Singapour',
    'gu-IN': 'સિંગાપોર ડોલર',
    'hi-IN': 'सिंगापुर डॉलर',
    'it-IT': 'Dollaro di Singapore',
    'ja-JP': 'シンガポールドル',
    'kn-IN': 'ಸಿಂಗಾಪುರ್ ಡಾಲರ್',
    'ko-KR': '싱가포르 달러',
    'ml-IN': 'സിംഗപ്പൂർ ഡോളർ',
    'mr-IN': 'सिंगापूर डॉलर',
    'nl-BE': 'Singaporese dollar',
    'nl-NL': 'Singaporese dollar',
    'pl-PL': 'Dolar singapurski',
    'pt-BR': 'Dólar de Cingapura',
    'pt-PT': 'Dólar de Singapura',
    'sv-SE': 'Singaporiansk dollar',
    'ta-IN': 'சிங்கப்பூர் டாலர்',
    'te-IN': 'సింగపూర్ డాలర్',
    'th-TH': 'ดอลลาร์สิงคโปร์',
    'tr-TR': 'Singapur doları',
    'vi-VN': 'Đô la Singapore',
    'zh-CN': '新加坡元',
    'zh-TW': '新加坡元',
  },
  'currency-selector-THB': {
    'en-US': 'Thai Baht',
    'ar-AE': 'بات تايلاندي',
    'bn-IN': 'থাই বাথ',
    'de-DE': 'Thailändischer Baht',
    'es-ES': 'Baht tailandés',
    'es-MX': 'Baht tailandés',
    'fr-BE': 'Baht thaïlandais',
    'fr-FR': 'Baht thaïlandais',
    'gu-IN': 'થાઈ બાહ્ટ',
    'hi-IN': 'थाई बाहत',
    'it-IT': 'Baht thailandese',
    'ja-JP': 'タイバーツ',
    'kn-IN': 'ಥಾಯ್ ಬಹ್ತ್',
    'ko-KR': '태국 바트',
    'ml-IN': 'തായ് ബട്ട്',
    'mr-IN': 'थाई बाहत',
    'nl-BE': 'Thaise baht',
    'nl-NL': 'Thaise baht',
    'pl-PL': 'Bat tajlandzki',
    'pt-BR': 'Baht tailandês',
    'pt-PT': 'Baht tailandês',
    'sv-SE': 'Thailändsk baht',
    'ta-IN': 'தாய் பாட்',
    'te-IN': 'థాయ్ బాట్',
    'th-TH': 'บาทไทย',
    'tr-TR': 'Tayland bahtı',
    'vi-VN': 'Bhat Thái',
    'zh-CN': '泰铢',
    'zh-TW': '泰銖',
  },
  'currency-selector-TRY': {
    'en-US': 'Turkish Lira',
    'ar-AE': 'ليرة تركية',
    'bn-IN': 'টার্কিশ লিরা',
    'de-DE': 'Türkische Lira',
    'es-ES': 'Lira turca',
    'es-MX': 'Lira turca',
    'fr-BE': 'Lire turque',
    'fr-FR': 'Lire turque',
    'gu-IN': 'ટર્કિશ લિરા',
    'hi-IN': 'तुर्की लीरा',
    'it-IT': 'Lira turca',
    'ja-JP': 'トルコリラ',
    'kn-IN': 'ಟರ್ಕಿಶ್ ಲಿರಾ',
    'ko-KR': '터키 리라',
    'ml-IN': 'ടർക്കിഷ് ലിറ',
    'mr-IN': 'तुर्की लिरा',
    'nl-BE': 'Turkse lira',
    'nl-NL': 'Turkse lira',
    'pl-PL': 'Lira turecka',
    'pt-BR': 'Lira turca',
    'pt-PT': 'Lira turca',
    'sv-SE': 'Turkisk lira',
    'ta-IN': 'துருக்கிய லிரா',
    'te-IN': 'టర్కిష్ లిరా',
    'th-TH': 'ลีราตุรกี',
    'tr-TR': 'Türk lirası',
    'vi-VN': 'Lira Thổ Nhĩ Kỳ',
    'zh-CN': '土耳其里拉',
    'zh-TW': '土耳其里拉',
  },
  'currency-selector-TWD': {
    'en-US': 'New Taiwan Dollar',
    'ar-AE': 'دولار تايواني جديد',
    'bn-IN': 'নিউ তাইওয়ান ডলার',
    'de-DE': 'Neuer Taiwan-Dollar',
    'es-ES': 'Nuevo dólar taiwanés',
    'es-MX': 'Nuevo dólar taiwanés',
    'fr-BE': 'Nouveau dollar de Taïwan',
    'fr-FR': 'Nouveau dollar de Taïwan',
    'gu-IN': 'ન્યુ તાઇવાન ડૉલર',
    'hi-IN': 'न्यू ताइवान डॉलर',
    'it-IT': 'Nuovo dollaro taiwanese',
    'ja-JP': '新台湾ドル',
    'kn-IN': 'ನ್ಯೂ ತೈವಾನ್ ಡಾಲರ್',
    'ko-KR': '신 대만 달러',
    'ml-IN': 'ന്യൂ തായ്‌വാൻ ഡോളർ',
    'mr-IN': 'नवीन तैवान डॉलर',
    'nl-BE': 'Nieuwe Taiwanese dollar',
    'nl-NL': 'Nieuwe Taiwanese dollar',
    'pl-PL': 'Nowy dolar tajwański',
    'pt-BR': 'Novo dólar taiwanês',
    'pt-PT': 'Novo Dólar de Taiwan',
    'sv-SE': 'Taiwanesisk dollar',
    'ta-IN': 'புதிய தைவான் டாலர்',
    'te-IN': 'న్యూ తైవాన్ డాలర్',
    'th-TH': 'ดอลลาร์ไต้หวันใหม่',
    'tr-TR': 'Yeni Tayvan doları',
    'vi-VN': 'Đô la Đài Loan mới',
    'zh-CN': '新台币',
    'zh-TW': '新台幣',
  },
  'currency-selector-UAH': {
    'en-US': 'Ukrainian Hryvnia',
    'ar-AE': 'هريفنيا أوكرانية',
    'bn-IN': 'ইউক্রেনীয় রিভনিয়া',
    'de-DE': 'Ukrainische Hryvnia',
    'es-ES': 'Grivna ucraniana',
    'es-MX': 'Grivna ucraniana',
    'fr-BE': 'Hryvnia ukrainienne',
    'fr-FR': 'Hryvnia ukrainienne',
    'gu-IN': 'યુક્રેનિયન રિવનિયા',
    'hi-IN': 'यूक्रेनियाई रिव्निया',
    'it-IT': 'Grivna ucraina',
    'ja-JP': 'ウクライナグリブナ',
    'kn-IN': 'ಉಕ್ರೇನಿಯನ್ ಹ್ರಿವ್ನಿಯಾ',
    'ko-KR': '우크라이나 흐리우냐',
    'ml-IN': 'ഉക്രേനിയൻ ഹ്രിവ്നിയ',
    'mr-IN': 'युक्रेनियन रिव्हनिया',
    'nl-BE': 'Oekraïense hryvnia',
    'nl-NL': 'Oekraïense hryvnia',
    'pl-PL': 'Hrywna ukraińska',
    'pt-BR': 'Hryvnia ucraniana',
    'pt-PT': 'Hryvnia Ucraniano',
    'sv-SE': 'Ukrainsk hryvnia',
    'ta-IN': 'உக்ரேனிய ஹிரிவ்னியா',
    'te-IN': 'ఉక్రేనియన్ హ్రివ్నియా',
    'th-TH': 'ฮริฟเนียยูเครน',
    'tr-TR': 'Ukrayna grivnası',
    'vi-VN': 'Hryvnia Ukraina',
    'zh-CN': '乌克兰格里夫尼亚',
    'zh-TW': '烏克蘭荷林夫納',
  },
  'currency-selector-USD': {
    'en-US': 'United States Dollars',
    'ar-AE': 'دولار أمريكي',
    'bn-IN': 'মার্কিন যুক্তরাষ্ট্রীয় ডলার',
    'de-DE': 'US-Dollar',
    'es-ES': 'Dólar estadounidense',
    'es-MX': 'Dólar estadounidense',
    'fr-BE': 'Dollars américains',
    'fr-FR': 'Dollars américains',
    'gu-IN': 'યુનાઇટેડ સ્ટેટ્સ ડોલર',
    'hi-IN': 'यूनाइटेड स्टेट्स डॉलर',
    'it-IT': 'Dollari statunitensi',
    'ja-JP': '米ドル',
    'kn-IN': 'ಯುನೈಟೆಡ್ ಸ್ಟೇಟ್ಸ್ ಡಾಲರ್‌',
    'ko-KR': '미국 달러',
    'ml-IN': 'യുണൈറ്റഡ് സ്റ്റേറ്റ്സ് ഡോളർ',
    'mr-IN': 'युनायटेड स्टेट्स डॉलर्स',
    'nl-BE': 'Amerikaanse dollar',
    'nl-NL': 'Amerikaanse dollar',
    'pl-PL': 'Dolary amerykańskie',
    'pt-BR': 'Dólares estadunidenses',
    'pt-PT': 'Dólares dos Estados Unidos',
    'sv-SE': 'Nordamerikansk dollar',
    'ta-IN': 'அமெரிக்க டாலர்',
    'te-IN': 'యునైటెడ్ స్టేట్స్ డాలర్‌లు',
    'th-TH': 'ดอลลาร์สหรัฐ',
    'tr-TR': 'Amerika Birleşik Devletleri doları',
    'vi-VN': 'Đô la Mỹ',
    'zh-CN': '美元',
    'zh-TW': '美元',
  },
  'currency-selector-VND': {
    'en-US': 'Vietnamese Dong',
    'ar-AE': 'دونغ فيتنامي',
    'bn-IN': 'ভিয়েতনামী ডং',
    'de-DE': 'Vietnamesischer Dong',
    'es-ES': 'Dong vietnamita',
    'es-MX': 'Dong vietnamita',
    'fr-BE': 'Dong vietnamien',
    'fr-FR': 'Dong vietnamien',
    'gu-IN': 'વિયેતનામીસ ડોંગ',
    'hi-IN': 'वियतनामी डोंग',
    'it-IT': 'Dong vietnamita',
    'ja-JP': 'ベトナムドン',
    'kn-IN': 'ವಿಯೆಟ್ನಾಮೀಸ್ ಡಾಂಗ್',
    'ko-KR': '베트남 동',
    'ml-IN': 'വിയറ്റ്നാമീസ് ഡോംഗ്',
    'mr-IN': 'व्हिएतनामी डोंग',
    'nl-BE': 'Vietnamese dong',
    'nl-NL': 'Vietnamese dong',
    'pl-PL': 'Dong wietnamski',
    'pt-BR': 'Dong vietnamita',
    'pt-PT': 'Dong vietnamita',
    'sv-SE': 'Vietnamesisk dong',
    'ta-IN': 'வியட்நாமிய டோங்',
    'te-IN': 'వియత్నామీస్ డాంగ్',
    'th-TH': 'ดองเวียดนาม',
    'tr-TR': 'Vietnam dongu',
    'vi-VN': 'Đồng Việt Nam',
    'zh-CN': '越南盾',
    'zh-TW': '越南盾',
  },
  'currency-selector-ZAR': {
    'en-US': 'South African Rand',
    'ar-AE': 'راند جنوب أفريقي',
    'bn-IN': 'দক্ষিণ আফ্রিকান র‍্যান্ড',
    'de-DE': 'Südafrikanischer Rand',
    'es-ES': 'Rand sudafricano',
    'es-MX': 'Rand sudafricano',
    'fr-BE': 'Rand sud-africain',
    'fr-FR': 'Rand sud-africain',
    'gu-IN': 'સાઉથ આફ્રિકન રેન્ડ',
    'hi-IN': 'दक्षिण अफ़्रीकी रैंड',
    'it-IT': 'Rand sudafricano',
    'ja-JP': '南アフリカランド',
    'kn-IN': 'ಸೌತ್ ಆಫ್ರಿಕನ್ ರಾಂಡ್',
    'ko-KR': '남아프리카 랜드',
    'ml-IN': 'ദക്ഷിണാഫ്രിക്കൻ റാൻഡ്',
    'mr-IN': 'दक्षिण आफ्रिकन रँड',
    'nl-BE': 'Zuid-Afrikaanse rand',
    'nl-NL': 'Zuid-Afrikaanse rand',
    'pl-PL': 'Rand południowoafrykański',
    'pt-BR': 'Rand sul-africano',
    'pt-PT': 'Rand sul-africano',
    'sv-SE': 'Sydafrikansk rand',
    'ta-IN': 'தென் ஆப்பிரிக்கன் ராண்ட்',
    'te-IN': 'దక్షిణ ఆఫ్రికా రాండ్',
    'th-TH': 'แรนด์แอฟริกาใต้',
    'tr-TR': 'Güney Afrika randı',
    'vi-VN': 'Rand Nam Phi',
    'zh-CN': '南非兰特',
    'zh-TW': '南非蘭特',
  },
};

export default katTranslator(strings);
